import { FeatureSlice, createFeature, Action } from '@ngrx/store';
import { createProfileReducer } from './create-profile-reducers';
import {
    AccountCreatedActionProps,
    AccountCreationFailedActionProps,
} from './actions/create-profile-service-actions';

export const CREATE_PROFILE_FEATURE: string = 'createProfile';

export type CreateProfileResult =
    | null
    | AccountCreatedActionProps
    | AccountCreationFailedActionProps;

export interface CreateProfileState {
    isWaitingForAPIResponse: boolean;
    result: CreateProfileResult;
}

export const createProfileFeature: FeatureSlice<CreateProfileState, Action> =
    createFeature({
        name: CREATE_PROFILE_FEATURE,
        reducer: createProfileReducer,
    });
